import { Text, Link } from '@cash-me/react-components'

import { CardProps } from './know-and-discover.model'

export const cards: CardProps[] = [
  {
    id: '01',
    title: 'Golpe da falsa Central de Atendimento',
    description: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          No golpe da falsa central de atendimento, fraudadores contatam vítimas sob a pretensão de 
          representar bancos ou empresas reais. Eles alertam sobre atividades financeiras suspeitas e, ao tentar 
          resolver a situação, solicitam senhas, códigos de segurança, TOKENs e até mesmo induzem a ligar para 
          números 0800 ou baixar aplicativos falsos de segurança bancária. 
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          O risco de confusão é alto, pois os golpistas frequentemente possuem informações básicas da vítima, 
          como nome completo. Recomenda-se adiar qualquer compartilhamento de dados e verificar a legitimidade 
          do contato com o gestor da conta. 
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Em caso de dúvidas,
          {' '}
          <Link
            href="https://www.cashme.com.br/blog/golpe-da-falsa-central-de-atendimento-como-se-proteger/"
            target="_blank"
            size="medium"
            inline
          >
            saiba mais aqui.
          </Link>
        </Text>
      </>
    )
  },
  {
    id: '02',
    title: 'Golpe do empréstimo com garantia de imóvel',
    description: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          O golpe do empréstimo com garantia de imóvel ocorre quando golpistas utilizam bens de 
          terceiros, inclusive familiares, como garantia para obtenção de crédito sem o conhecimento destes. 
          Todas as informações das vítimas (amigos, mães, pais, avós, etc.) são apresentadas, e as assinaturas 
          dos proprietários dos imóveis são falsificadas para obter sucesso na aquisição do empréstimo. 
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Como esse tipo de abordagem costuma ocorrer através de pessoas próximas, o risco é alto. Assegure-se 
          de assinar operações de crédito exclusivamente com instituições financeiras que tenham políticas de 
          segurança para atividades realizadas por meio de procuração e proteção de pessoas idosas. 
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Em caso de dúvidas,
          {' '}
          <Link
            href="https://www.cashme.com.br/blog/golpes-de-emprestimo-descubra-os-4-mais-comuns/"
            target="_blank"
            size="medium"
            inline
          >
            saiba mais aqui.
          </Link>
        </Text>
      </>
    )
  },
  {
    id: '03',
    title: 'Golpe do falso investimento ou falso ganho',
    description: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          No golpe do falso investimento ou ganho, indivíduos ou empresas atraem vítimas com 
          propostas de investimento prometendo lucros extraordinários. Muitas vezes, incentivam a obtenção de 
          empréstimos com garantia de imóvel para financiar o investimento. O golpista administra o dinheiro 
          emprestado, comprometendo-se falsamente a pagar as parcelas e entregar lucros desproporcionais ao mercado.  
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          A participação ativa da vítima complica a situação, pois ela assina o contrato, dificultando o 
          cancelamento do empréstimo e prejudicando sua segurança financeira. Ao receber propostas semelhantes, 
          é aconselhável buscar orientação de especialistas ou instituições de crédito confiáveis. 
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Em caso de dúvidas,
          {' '}
          <Link
            href="https://www.cashme.com.br/blog/golpe-do-falso-investimento/"
            target="_blank"
            size="medium"
            inline
          >
            saiba mais aqui.
          </Link>
        </Text>
      </>
    )
  },
  {
    id: '04',
    title: 'Golpe do empréstimo com pagamento adiantado',
    description: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          O golpe do empréstimo com pagamento adiantado ocorre quando fraudadores solicitam taxas 
          antecipadas para garantir a aprovação do empréstimo, alegando que esse adiantamento cobrirá 
          procedimentos e servirá como seguro para a operação, análise de crédito ou garantias. 
          Após receberem o pagamento, os golpistas desaparecem ou não concedem o crédito prometido, causando 
          prejuízo financeiro à vítima, que não obtém o esperado. 
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Como essa abordagem envolve um pagamento menor em relação ao empréstimo, o risco é alto. Não importa 
          o quão convincente seja o discurso, se solicitarem pagamento adiantado, é motivo para duvidar. 
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Em caso de dúvidas,
          {' '}
          <Link
            href="https://www.cashme.com.br/blog/golpes-de-emprestimo-descubra-os-4-mais-comuns/"
            target="_blank"
            size="medium"
            inline
          >
            saiba mais aqui.
          </Link>
        </Text>
      </>
    )
  },
  {
    id: '05',
    title: 'Golpe da falsa dívida',
    description: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          O golpe da falsa dívida ocorre quando os fraudadores entram em contato com as vítimas, 
          geralmente por telefone, mensagens de texto ou e-mail, alegando que a pessoa possui dívidas pendentes 
          que precisam ser quitadas imediatamente para evitar o bloqueio e a perda de bens. Apresentam 
          informações falsas, cobrando supostos débitos com urgência, com o objetivo de fazer a vítima se 
          desesperar, fornecer informações pessoais e efetuar o pagamento sem verificar a legitimidade da dívida. 
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Como esse tipo de abordagem envolve a pressão e vulnerabilidade psicológica, o risco é alto. 
          Sempre que receber uma cobrança inesperada, verifique a situação antes de tomar qualquer decisão. 
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Em caso de dúvidas,
          {' '}
          <Link
            href="https://www.cashme.com.br/blog/golpe-da-divida-falsa/"
            target="_blank"
            size="medium"
            inline
          >
            saiba mais aqui.
          </Link>
        </Text>
      </>
    )
  },
  {
    id: '06',
    title: 'Golpe do boleto falso por e-mail e interceptação',
    description: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          O golpe do boleto falso é uma prática fraudulenta comumente realizada por meio de e-mails 
          falsificados ou interceptados. No primeiro método, os golpistas enviam boletos adulterados para vítimas 
          que não verificam cuidadosamente o remetente. No segundo, eles bloqueiam e-mails legítimos de cobrança 
          da vítima, substituindo-os por e-mails com boletos falsos. 
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Esta abordagem, envolvendo o vazamento de dados ou invasão de e-mails, representa alto risco. 
          Recomenda-se sempre verificar o remetente dos e-mails e consultar o gerente da instituição financeira 
          para confirmar a autenticidade do boleto. 
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Em caso de dúvidas,
          {' '}
          <Link
            href="https://www.cashme.com.br/blog/golpe-do-boleto-falso/"
            target="_blank"
            size="medium"
            inline
          >
            saiba mais aqui.
          </Link>
        </Text>
      </>
    )
  }
]
